import React, { PureComponent } from "react";
import { injectIntl, FormattedHTMLMessage } from "react-intl";
import { CardIcon } from "./Icons";

import "./Thanks.css";

export default injectIntl(
  class Thanks extends PureComponent {
    render() {
      const { intl, school, newInscription } = this.props;
      return (
        <div className="cm-thanks">
          <div className="cm-thanks--header">
            {/* <img
              src="/images/logo-clubmed.svg"
              alt="Club Med"
              className="cm-thanks--clubmed"
            /> */}
          </div>
          <div className="cm-thanks--outer">
            <img
              src="/images/logo-esf.svg"
              alt="ESF"
              className="cm-thanks--logo"
            />
            <div className="cm-thanks--content">
              <FormattedHTMLMessage
                id="thanks_message"
                values={{ school: school }}
              />
            </div>
            <button className="cm-thanks--inscription" onClick={newInscription}>
              <div className="cm-thanks--icon">
                <CardIcon className="cm-thanks--card" />
              </div>
              <div className="cm-thanks--text">
                {intl.messages.other_inscription}
              </div>
            </button>
          </div>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Thanks.js